import { Fancybox } from "@fancyapps/ui";

const theme_color = document.getElementsByTagName('meta')["theme-color"]

Fancybox.bind("[data-fancybox]", {
  dragToClose: false,
});


Fancybox.bind("[data-fancybox]", {
  dragToClose: false,
  on: {
    reveal: (fancybox, slide) => {
      theme_color.content = "#FDF6E6";
    },
    close: (fancybox, slide) => {
      theme_color.content = theme_color.getAttribute('data-default');
    },
  },
});
